import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;
const inputCls =
  "w-full bg-transparent border-b border-ivory/25 focus:border-blush outline-none py-3 text-ivory placeholder:text-ivory/30 transition-colors duration-300";

export default function ChangePassword({ token }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirm) { toast.error("The new passwords do not match."); return; }
    if (next.length < 8) { toast.error("New password must be at least 8 characters."); return; }
    setBusy(true);
    try {
      await axios.post(
        `${API}/api/auth/change-password`,
        { current_password: current, new_password: next },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success("Password updated — use it next time you sign in.");
      setCurrent(""); setNext(""); setConfirm("");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Could not update the password.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="change-password" className="max-w-md">
      <p className="text-[11px] tracking-[0.3em] uppercase text-gold mb-2">Account Security</p>
      <h2 className="font-serif text-2xl text-ivory mb-2">Change your password</h2>
      <p className="text-ivory/50 text-sm font-light mb-8">
        Pick something long and unique — at least 8 characters. Your new password sticks even across updates and redeploys.
      </p>
      <form onSubmit={submit} className="space-y-6">
        <input data-testid="cp-current" type="password" required placeholder="Current password" value={current} onChange={(e) => setCurrent(e.target.value)} className={inputCls} />
        <input data-testid="cp-new" type="password" required placeholder="New password" value={next} onChange={(e) => setNext(e.target.value)} className={inputCls} />
        <input data-testid="cp-confirm" type="password" required placeholder="Confirm new password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className={inputCls} />
        <button
          data-testid="cp-submit"
          type="submit"
          disabled={busy}
          className="inline-flex items-center gap-2 rounded-full bg-blush text-midnight text-[12px] tracking-[0.2em] uppercase font-medium px-7 py-3.5 hover:bg-gold transition-colors duration-300 disabled:opacity-50"
        >
          <KeyRound size={15} /> {busy ? "Updating…" : "Update password"}
        </button>
      </form>
    </div>
  );
}
